import { Component } from '@angular/core';
import { NgClass, NgStyle, NgTemplateOutlet } from '@angular/common';
import {
  flashAnimation,
  fadeInAnimation,
  fadeOutAnimation,
  fadeInOnEnterAnimation,
  fadeOutOnLeaveAnimation,
  shakeAnimation,
  headShakeAnimation,
} from 'angular-animations';
import {
  SafePipe,
  PlayButtonComponent,
  SlidePanelComponent
} from '@nx-superprep/shared';

import { GameplayBaseComponent, gameplaySpacing } from '../gameplay-base';
import { MatCardModule } from '@angular/material/card'
import { MatGridListModule } from '@angular/material/grid-list'

@Component({
  standalone: true,
  selector: 'gameplay-tiles',
  templateUrl: './tiles.component.html',
  styleUrls: ['./tiles.component.scss'],
  animations: [
    flashAnimation(),
    fadeInAnimation(),
    fadeOutAnimation(),
    fadeInOnEnterAnimation(),
    fadeOutOnLeaveAnimation(),
    headShakeAnimation({ duration: 900, delay: 0 }),
    shakeAnimation({ duration: 200, delay: 0, translate: '3px' }),
  ],
  imports: [
    NgClass, NgStyle, NgTemplateOutlet, SafePipe,
    MatCardModule,
    MatGridListModule,
    SlidePanelComponent, PlayButtonComponent
  ]
})
export class TilesComponent extends GameplayBaseComponent {
  override title = 'tiles'

  /**
   * Returns the end text based on whether the answer has been given and if the question has an image.
   * If the answer has been given and the question has an image, returns a small spacer.
   * Otherwise, returns the result from the parent class's `endText` method.
   */
  override endText() {
    return this.didAnswer && this.question?.hasImage ? gameplaySpacing.smallSpacer : super.endText()
  }

  /**
   * Determines the number of columns based on the viewport size.
   * If the viewport width or height is less than 540 pixels, returns 4 columns.
   * Otherwise, returns the result from the parent class's `cols` method.
   */
  override get cols(): number {
    return window.visualViewport && Math.max(window.visualViewport.width, window.visualViewport.height) < 540 ? 4 : super.cols
  }

  /**
   * Returns the gutter size based on the device type.
   * If in mobile view, returns '24px'. Otherwise, returns '20px'.
   */
  override get gutterSize() {
    return this.isMobileView ? '24px' : '20px'
  }
}
